import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "search" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 9.813,
			cy: 9.812,
			r: 9.063,
			transform: "translate(-3.056 4.62) rotate(-23.025)"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.221,
			y1: 16.22,
			x2: 23.25,
			y2: 23.25
		})
	]
});
export default SvgSearch;
